<!--Mobile view from nav bar-->
<div *ngIf="buttonType === 'mobile-nav'">
    <div class="d-block d-sm-block d-lg-none d-xl-none btn btn-lg btn-icon-only btn-success"
         style=" margin-right:15px;"
         ngfSelect
         [multiple]="1"
         (filesChange)="quickAddExpense()"
         [ngfFixOrientation]="false"
         [(lastInvalids)]="lastInvalids"
         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
         [(files)]="uploadedFiles">
        <span><b>{{currencySymbol}}</b></span>
    </div>
</div>

<!--Desktop view from expense page-->
<div *ngIf="buttonType === 'desktop-expense'">
    <div ngfDrop
         multiple="1"
         selectable="1"
         [(files)]="uploadedFiles"
         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
         class="btn btn-outline-dark"
         (filesChange)="quickAddExpense()"
         [(lastInvalids)]="lastInvalids"
         [ngfFixOrientation]="false">
        <span class="oi oi-camera-slr"></span> Quick Add
    </div>
</div>
<!--Mobile view from expense page-->
<div *ngIf="buttonType === 'mobile-expense'">
    <label><strong>Quick Add</strong></label>
    <br />
    <br />
    <span ngfDrop
          multiple="1"
          selectable="1"
          [(files)]="uploadedFiles"
          accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
          class="hotlistIcon"
          (filesChange)="quickAddExpense()"
          [(lastInvalids)]="lastInvalids"
          [ngfFixOrientation]="false"
          style="color: #fff;background-color: #7fa3f5;border-color: #6785c7;">
        <span class="oi oi-camera-slr"></span>
    </span>
</div>